<template>
    <v-container fluid>
        <v-row class="ma-0 pa-0" >
            <v-progress-linear
                class="mb-8"
                color="primary"
                indeterminate
                v-if="loading"
            ></v-progress-linear>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-text class="ma-0 pa-0">
                            <v-simple-table>
                                <template v-slot:default>
                                <thead class="primary">
                                    <tr>
                                    <th class="text-left white--text">
                                        Código
                                    </th>
                                    <th class="text-left white--text">
                                        Descrição
                                    </th>
                                    <th class="text-left white--text">
                                        Opções
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                    v-for="item in obras_user"
                                    :key="item.Id"
                                    >
                                    <td>{{ item.Codigo }}</td>
                                    <td>{{ item.Descricao }}</td>
                                    <td>
                                        <IconRemove
                                            v-if="$store.getters.hasPermission(['super', 'works.user_accesses_manage'])"
                                            @on-submit="deleteObra(item)"
                                        />                                                    
                                    </td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    <v-card-actions>
                        <v-row>
                            <v-col cols="12" md="10">
                                <v-autocomplete
                                    :items="obras"
                                    label="Associar obra"
                                    v-model="obra_selected"
                                    dense outlined
                                    item-value="Id"
                                    :item-text="item=> item.Codigo + ' - ' + item.Descricao"
                                />
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn
                                    icon
                                    @click="adicionarObra"
                                    :disabled="obra_selected == null"
                                    class="primary"
                                >
                                    <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Works from '@/api/Works.js'
import Obra from '@/api/Obra.js'
import User from '@/api/User.js'
import IconRemove from '@/components/UI/IconRemove.vue';

export default{
    name: 'ObrasAssociadas',
    components:{
        IconRemove
    },
    props:{
        obras_user:{
            typeof: Array,
            default: []
        }
    },
    data(){
        return{
            reloadObras: 9999,
            loading: false,
            obra_selected: null,
            obras: []
        }
    },
    mounted(){
        this.loading = true
        Obra.onlyWorks().then((resp)    =>  {
            this.obras = resp.data
            this.loading = false
        })

    },
    methods:{     
        deleteObra(item){
            this.loading = true
            let data = {
                work_id: item.Id,
                user_id: this.$route.params.id
            }
            Works.deleteUser(item.Id, data).then((resp)    =>  {
                this.$emit('reload')
                this.success = true
                this.loading = false
            })
        },
        adicionarObra(){
            this.loading = true
            let data = {
                work_id: this.obra_selected,
                user_id: this.$route.params.id
            }
            Works.addUser(this.obra_selected, data).then((resp)   =>  {
                this.success = true
                this.obra_selected = null
                this.$emit('reload')
                this.loading = false
            })
        },   
    }
}
</script>